var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWarningAmber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.99173L16.275 15.8334H3.725L10 4.99173ZM2.28333 15.0001C1.64167 16.1084 2.44167 17.5001 3.725 17.5001H16.275C17.5583 17.5001 18.3583 16.1084 17.7167 15.0001L11.4417 4.1584C10.8 3.05007 9.2 3.05007 8.55833 4.1584L2.28333 15.0001ZM9.16667 9.16673V10.8334C9.16667 11.2917 9.54167 11.6667 10 11.6667C10.4583 11.6667 10.8333 11.2917 10.8333 10.8334V9.16673C10.8333 8.7084 10.4583 8.3334 10 8.3334C9.54167 8.3334 9.16667 8.7084 9.16667 9.16673ZM9.16667 13.3334H10.8333V15.0001H9.16667V13.3334Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningAmber);
export default __webpack_public_path__ + "static/media/alert_warning_amber.55f14ca7b9a4b6971043dd5ab8bb9dc9.svg";
export { ForwardRef as ReactComponent };